import { render, staticRenderFns } from "./VPage.vue?vue&type=template&id=0fc00c2c&"
import script from "./VPage.vue?vue&type=script&lang=ts&"
export * from "./VPage.vue?vue&type=script&lang=ts&"
import style0 from "./VPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports